import plural from 'helpers/plural';

angular.module('gym.calendar').controller('EventAttendeesModalCtrl', ["$scope", "$rootScope", "$stateParams", "$state", "$modalInstance", "$filter", "$window", "$http", "$timeout", "$interval", "$modal", "$q", "flash", "EventMessageService", "EmploymentService", "EventService", "ContactBadgeService", "FeatureAvailabilityService", "MasqueradingService", "CwStorage", "Events", "DrawerService", "ReactModal", "KioskService", "MessageService", "event", "params", "refetchDashlets", function($scope, $rootScope, $stateParams, $state, $modalInstance, $filter, $window, $http, $timeout, $interval, $modal, $q, flash, EventMessageService, EmploymentService, EventService, ContactBadgeService, FeatureAvailabilityService, MasqueradingService, CwStorage, Events, DrawerService, ReactModal, KioskService, MessageService, event, params, refetchDashlets) {
  var getBookings, getCancelledBookings, gym, intervalId, reloadEvent, selectedContactsIds, sortBookings;
  gym = $scope.gym = $rootScope.gym;
  $scope.currency = gym.currency_symbol;
  $scope.permissions = EmploymentService.get().permissions;
  $scope.isLoading = true;
  $scope.event = event;
  $scope.eventNote = event.notes;
  $scope.isMasquerading = MasqueradingService.isMasquerading();
  $scope.selectedContacts = [];
  $scope.calendarRoute = $rootScope.defaultCalendarView || 'gym.calendar';
  $scope.showCalendarLink = params != null ? params.showCalendarLink : void 0;
  $scope.isZeroBookingEvent = false;
  $scope.$watch('event.participant_limit', function(newVal) {
    if (!((newVal != null) || newVal === 0)) {
      return;
    }
    return $scope.isZeroBookingEvent = newVal === 0 || newVal === (void 0) || newVal === null;
  });
  intervalId = $interval(function() {
    return reloadEvent({
      autoUpdate: true
    }, true);
  }, 20000);
  $scope.$on('$destroy', function() {
    return $interval.cancel(intervalId);
  });
  $scope.getRecurringBookings = function() {
    if (!$scope.event.event_schedule_id) {
      return;
    }
    if (!gym.gym_config.recurring_bookings_feature_enabled) {
      return;
    }
    params = {
      event_schedule_id: $scope.event.event_schedule_id
    };
    return EventService.getRecurringBookings(params).then(function(recurringBookings) {
      return $scope.recurringBookings = recurringBookings;
    });
  };
  $scope.isContactSelected = function(contact) {
    return _.find($scope.selectedContacts, function(selected) {
      return selected.id === contact.id;
    });
  };
  $scope.migrateEventSeries = function() {
    return ReactModal.open({
      component: 'MigrateEventSeriesModal',
      props: {
        eventId: event.id,
        eventName: event.name,
        closeAttendeeModal: $scope.close
      }
    });
  };
  $scope.toggleContact = function(contact) {
    if ($scope.isContactSelected(contact)) {
      return $scope.selectedContacts = _.reject($scope.selectedContacts, function(selected) {
        return selected.id === contact.id;
      });
    } else {
      return $scope.selectedContacts.push(contact);
    }
  };
  $scope.openBulkAddAttendees = function(event) {
    return ReactModal.open({
      component: 'BulkAddAttendeesModal',
      size: 'lg',
      props: {
        event: event,
        from: 'event_attendees_modal',
        refetchDashlets: refetchDashlets
      }
    });
  };
  $scope.toggleAll = function(event) {
    event.preventDefault();
    $scope.selectedContacts = $scope.selectedContacts.length ? [] : _.uniq($scope.selectedContacts.concat($scope.bookings), function(item) {
      return item.id;
    });
    return $timeout(function() {
      return $scope.isAllInvoicesSelected = !!$scope.selectedContacts.length;
    });
  };
  $scope.isAllContactsSelected = function() {
    var ref;
    return ((ref = $scope.bookings) != null ? ref.length : void 0) && _.every($scope.bookings, function(contact) {
      return $scope.isContactSelected(contact);
    });
  };
  $scope.isAllCancelledSelected = function() {
    var ref;
    return ((ref = $scope.cancelledBookings) != null ? ref.length : void 0) && _.every($scope.cancelledBookings, function(booking) {
      return $scope.isContactSelected(booking);
    });
  };
  $scope.toggleAllCancelled = function(event) {
    event.preventDefault();
    $scope.selectedContacts = $scope.selectedContacts.length ? [] : _.uniq($scope.selectedContacts.concat($scope.cancelledBookings), function(item) {
      return item.id;
    });
    return $timeout(function() {
      return $scope.isAllInvoicesSelected = !!$scope.selectedContacts.length;
    });
  };
  selectedContactsIds = function() {
    return _.uniq($scope.selectedContacts.map(function(item) {
      return item.id;
    }));
  };
  getBookings = function() {
    return EventService.getBookings(event.id);
  };
  getCancelledBookings = function() {
    var eventCancellationId, ref;
    if (!$scope.event.cancelled) {
      return $q.resolve([]);
    }
    eventCancellationId = (ref = $scope.event.cancellation_details) != null ? ref.event_cancellation_id : void 0;
    return EventService.getCancelledBookings(event.id, eventCancellationId).then(function(bookings) {
      return bookings;
    }, function(error) {
      return [];
    });
  };
  reloadEvent = function(params, hideLoadingPlaceholder) {
    var promises;
    if (!hideLoadingPlaceholder) {
      $scope.isLoading = true;
    }
    promises = [Events.get(event.id), getBookings()];
    if ($scope.event.cancelled) {
      promises.push(getCancelledBookings());
    }
    $q.all(promises).then(function(response) {
      angular.extend($scope.event, response[0]);
      $scope.getRecurringBookings();
      $scope.bookings = sortBookings(response[1]);
      $scope.event.bookings_count = $scope.bookings.length;
      if ($scope.event.cancelled && response[2]) {
        $scope.cancelledBookings = response[2];
      }
      if (!(params != null ? params.autoUpdate : void 0)) {
        $scope.eventNote = $scope.event.notes;
      }
      $scope.eventStatus = EventService.status($scope.event);
      $scope.selectedContacts = $scope.selectedContacts.filter(function(contact) {
        return _.find($scope.bookings, function(booking) {
          return booking.id === contact.id;
        });
      });
      return $scope.instructorNames = event.instructor_names.join(', ');
    });
    if (!hideLoadingPlaceholder) {
      return $scope.isLoading = false;
    }
  };
  reloadEvent();
  $scope.placeholderContacts = _.times(event.bookings_count || 0, function(n) {
    return n;
  });
  $scope.placeholderWaitlistContacts = _.times(event.waitlist_attendee_count || 0, function(n) {
    return n;
  });
  $scope.close = function() {
    return $modalInstance.close();
  };
  DrawerService.closeOnRouteChange($scope, $scope.close);
  $scope.showMigrateButton = function(event) {
    return event.event_series_id && $scope.isMasquerading && event.infinite && !$scope.showCalendarLink;
  };
  sortBookings = function(bookings) {
    return _.sortBy(bookings, function(booking) {
      switch ($scope.params.sortBy) {
        case 'lastName':
          return booking.student.last_name.toLowerCase();
        case 'firstName':
          return booking.student.first_name.toLowerCase();
        case 'bookingCreated':
          return booking.id;
      }
    });
  };
  $scope.params = {
    sortBy: CwStorage.getItem('attendeesModalSortBy') || 'lastName'
  };
  $scope.setSorting = function(sortBy) {
    $scope.params.sortBy = sortBy;
    CwStorage.setItem('attendeesModalSortBy', sortBy);
    return $scope.bookings = sortBookings($scope.bookings);
  };
  $scope.attendanceStatusTooltip = function(booking) {
    switch (booking.attendance) {
      case 'Attended':
        return 'Booking has been marked as attended';
      case 'Absent':
        return 'Booking has been marked as absent';
      default:
        return 'Attendance has not been marked for this booking';
    }
  };
  $scope.displayTime = function() {
    var end, endFormatted, start, startFormatted;
    start = moment.isDate(event.start) ? event.start : moment(event.start || event.start_at, 'YYYY/MM/DD HH:mm').toDate();
    end = moment.isDate(event.end) ? event.end : moment(event.end || event.end_at, 'YYYY/MM/DD HH:mm').toDate();
    startFormatted = $filter('date')(start, 'h:mm a');
    endFormatted = $filter('date')(end, 'h:mm a, EEEE, MMMM, d, yyyy');
    return `${startFormatted} - ${endFormatted}`;
  };
  $scope.showEvent = function(redirectParams) {
    var eventState;
    $scope.close();
    eventState = event.event_schedule_id ? 'gym.editEvent' : 'gym.showEvent';
    return $state.go(eventState, {
      eventId: event.id,
      location_id: params != null ? params.location_id : void 0,
      instructor_id: params != null ? params.instructor_id : void 0,
      editSection: redirectParams != null ? redirectParams.editSection : void 0
    });
  };
  $scope.messageAttendees = function() {
    EventMessageService.messageAttendees($scope.selectedContacts);
    $scope.close();
    return $state.go('gym.bulkMessages.new', {
      eventId: event.id,
      from: 'calendar_event'
    });
  };
  $scope.sendMessage = function(booking) {
    EventMessageService.messageAttendees([booking]);
    $scope.close();
    return $state.go('gym.bulkMessages.new', {
      eventId: event.id,
      from: 'calendar_event'
    });
  };
  $scope.resetAttendance = function(booking) {
    if (window.confirm("This will reset the attendance status for this booking. Are you sure?")) {
      booking.attendance = null;
      return EventService.resetAttendance(booking, reloadEvent);
    }
  };
  $scope.updateAttendance = function(booking, value) {
    var previousValue;
    previousValue = booking.attendance;
    booking.attendance = value;
    return EventService.confirmUpdateAttendance({
      event: $scope.event,
      booking: booking,
      studentName: booking.student.name,
      previousValue: previousValue,
      reloadAttendance: reloadEvent
    });
  };
  $scope.bulkMarkAttended = function() {
    var count, message, url;
    count = $scope.selectedContacts.length;
    message = `This will mark ${plural('bookings', count, true)} as attended. Are you sure?`;
    if (window.confirm(message)) {
      url = `/gyms/${gym.id}/calendar/events/${event.id}/bulk_bookings/mark_attended`;
      params = {
        ids: _.pluck($scope.selectedContacts, 'id')
      };
      return $http.post(url, params).then(function(response) {
        var failedContacts;
        reloadEvent();
        if (response.data.at_least_one_failure) {
          failedContacts = _.chain(response.data.failure_messages || {}).toArray().pluck('contact_name').value();
          return MessageService.message({
            title: 'Attendance blocked (signed waiver required)',
            message: ['Attendance could not be marked for the following contacts, as they have not yet signed the required waivers:'].concat(failedContacts)
          });
        }
      }, function() {
        return flash.error = "Request could not be completed. Please try again";
      });
    }
  };
  $scope.bulkMarkAbsent = function() {
    var count, message, url;
    count = $scope.selectedContacts.length;
    message = `This will mark ${plural('bookings', count, true)} as absent. Are you sure?`;
    if (window.confirm(message)) {
      url = `/gyms/${gym.id}/calendar/events/${event.id}/bulk_bookings/mark_absent`;
      params = {
        ids: _.pluck($scope.selectedContacts, 'id')
      };
      return $http.post(url, params).then(function() {
        return reloadEvent();
      }, function() {
        return flash.error = "Request could not be completed. Please try again";
      });
    }
  };
  $scope.bulkCancel = function() {
    var count, message, url;
    count = $scope.selectedContacts.length;
    message = `This will cancel ${plural('bookings', count, true)}. Are you sure?`;
    if (window.confirm(message)) {
      url = `/gyms/${gym.id}/calendar/events/${event.id}/bulk_bookings/cancel`;
      params = {
        ids: _.pluck($scope.selectedContacts, 'id')
      };
      return $http.post(url, params).then(function() {
        return reloadEvent();
      }, function() {
        return flash.error = "Request could not be completed. Please try again";
      });
    }
  };
  $scope.noPlacesAvailable = function() {
    return $scope.event.non_absent_bookings_count >= $scope.event.participant_limit;
  };
  $scope.showInfo = function(booking) {
    return $modal.open({
      template: require('templates/gyms/calendar/events/booking_info_modal.html.slim'),
      resolve: {
        booking: function() {
          return booking;
        }
      },
      controller: 'BookingInfoCtrl'
    });
  };
  $scope.remove = function(booking) {
    return EventService.removeBooking(booking, $scope.event).then(function() {
      if (typeof refetchDashlets === "function") {
        refetchDashlets();
      }
      return reloadEvent();
    });
  };
  $scope.addBooking = function(contact) {
    return EventService.addBooking(contact, $scope.event, $scope.bookings).then(function() {
      if (typeof refetchDashlets === "function") {
        refetchDashlets();
      }
      return reloadEvent();
    });
  };
  $scope.getRecurringBooking = function(contactId) {
    var ref;
    return (ref = $scope.recurringBookings) != null ? ref.find(function(item) {
      return item.contact_id === contactId;
    }) : void 0;
  };
  $scope.enableRecurringBookingsVisible = function(contactId) {
    return $scope.event.event_schedule_id && gym.gym_config.recurring_bookings_feature_enabled && $scope.event.all_events_count > 1 && !$scope.getRecurringBooking(contactId);
  };
  $scope.enableRecurringBookings = function(booking, fromWaitlist) {
    var modalInstance;
    modalInstance = ReactModal.open({
      component: 'EnableRecurringBookingsModal',
      props: {
        booking: booking,
        event: $scope.event.plain(),
        fromWaitlist: fromWaitlist
      }
    });
    return modalInstance.then(function() {
      return reloadEvent();
    });
  };
  $scope.disableRecurringBookings = function(booking) {
    var modalInstance;
    modalInstance = ReactModal.open({
      component: 'DisableRecurringBookingsModal',
      props: {
        booking: booking,
        event: $scope.event.plain(),
        recurringBooking: $scope.getRecurringBooking(booking.contact_id || booking.student.id)
      }
    });
    return modalInstance.then(function() {
      return reloadEvent();
    });
  };
  $scope.showAllBookingsAvailable = function(booking) {
    var ref;
    return $scope.event.event_schedule_id && $scope.event.all_events_count > 1 && (((ref = booking.contact_type) != null ? ref.toLowerCase() : void 0) === 'member' || booking.student.type === 'member');
  };
  $scope.showAllBookings = function(booking) {
    return ReactModal.open({
      component: 'BookedEventsInSeriesModal',
      drawer: true,
      props: {
        booking: booking,
        event: $scope.event.plain()
      }
    });
  };
  $scope.addToWaitlist = function(contact) {
    return EventService.addToWaitlist(contact, $scope.event).then(function() {
      return reloadEvent();
    });
  };
  $scope.removeFromWaitlist = function(waitlist) {
    return EventService.removeFromWaitlist(waitlist).then(function() {
      return reloadEvent();
    });
  };
  $scope.changeWaitlistPosition = function(waitlist, change) {
    return EventService.changeWaitlistPosition(waitlist, change).then(function() {
      return reloadEvent();
    });
  };
  $scope.bookNow = function(waitlist) {
    return EventService.bookNow(waitlist, $scope.event).then(function() {
      return reloadEvent();
    });
  };
  $scope.getContactBadge = function(type, status) {
    return ContactBadgeService.get(type, status);
  };
  $scope.waitlistPlacesAvailable = function() {
    return EventService.waitlistPlacesAvailable($scope.event);
  };
  $scope.onNoteChange = function() {
    return $scope.saveNote();
  };
  $scope.saveNote = _.debounce(function() {
    var url;
    if (!$scope.permissions.manage_events) {
      return;
    }
    url = `/gyms/${gym.id}/calendar/events/${event.id}/update_notes`;
    return $http.put(url, {
      event: {
        notes: $scope.eventNote
      }
    }).then(function() {
      $scope.noteUpdated = true;
      return $timeout(function() {
        return $scope.noteUpdated = false;
      }, 3000);
    });
  }, 700);
  $scope.getContactRoute = function(contact) {
    var id, type;
    type = (contact.type || contact.contact_type).toLowerCase();
    id = contact.contact_id || contact.id;
    return `gym.contacts.edit({contactType: '${type + 's'}', contactId: ${id}})`;
  };
  $scope.isBirthday = function(contact) {
    return contact.dob && moment(contact.dob).format('DD-MM') === moment().format('DD-MM');
  };
  $scope.goToEventKiosk = function() {
    if (FeatureAvailabilityService.isAvailable('attendance')) {
      params = {
        event_id: event.id,
        location_id: $stateParams.location_id
      };
      return KioskService.enterClassKioskMode(params);
    } else {
      $scope.close();
      return FeatureAvailabilityService.showNotAvailableMessage('General Kiosk');
    }
  };
  $scope.isEventInPast = function() {
    return moment($scope.event.event_date).isBefore(moment().tz($scope.gym.tz), 'day');
  };
  $scope.goToRollCall = function() {
    var url;
    if (FeatureAvailabilityService.isAvailable('attendance')) {
      url = `/gyms/${gym.id}/roll_call/${event.id}`;
      $window.open(url, '_self');
      return true;
    } else {
      $scope.close();
      return FeatureAvailabilityService.showNotAvailableMessage('General Kiosk');
    }
  };
  $scope.refreshCounters = function() {
    $scope.refreshCountersLoading = true;
    return Events.one(`${event.id}`).doPUT({}, 'reset_counters').then(function(response) {
      var ref;
      if ((response != null ? (ref = response.bookings) != null ? ref.collection : void 0 : void 0) != null) {
        $scope.event.bookings_count = response.bookings.collection.length;
        $scope.bookings = sortBookings(response.bookings.collection);
      }
      $scope.event.vacancies_count = response.vacancies_count;
      $scope.event.waitlist_attendee_count = response.waitlist_attendee_count;
      $scope.refreshCountersLoading = false;
      return flash.success = "Updated successfully";
    }, function() {
      $scope.refreshCountersLoading = false;
      return flash.error = 'An error occurred updating the counters.';
    });
  };
  $scope.editEvent = function() {
    $scope.close();
    return EventService.goToEdit(event);
  };
  $scope.getCancelledBookingsCount = function() {
    if (!$scope.cancelledBookings) {
      return 0;
    }
    return $scope.cancelledBookings.filter(function(booking) {
      var ref;
      return !((ref = booking.move_details) != null ? ref.moved_to_event_id : void 0);
    }).length;
  };
  $scope.getMovedBookingsCount = function() {
    if (!$scope.cancelledBookings) {
      return 0;
    }
    return $scope.cancelledBookings.filter(function(booking) {
      var ref;
      return (ref = booking.move_details) != null ? ref.moved_to_event_id : void 0;
    }).length;
  };
  $scope.isBookingMoved = function(booking) {
    var ref;
    return ((ref = booking.move_details) != null ? ref.moved_to_event_id : void 0) != null;
  };
  $scope.formatEventDateTime = function(startAt, endAt) {
    var dateStr, endDate, endTimeStr, startDate, startTimeStr;
    if (!(startAt && endAt)) {
      return '';
    }
    startDate = new Date(startAt);
    endDate = new Date(endAt);
    dateStr = $filter('date')(startDate, 'EEE d MMM yyyy');
    startTimeStr = $filter('date')(startDate, 'h:mm a');
    endTimeStr = $filter('date')(endDate, 'h:mm a');
    return `${dateStr}, ${startTimeStr} - ${endTimeStr}`;
  };
  return $scope.getMovedEventTime = function(moveDetails) {
    var dateStr, endDate, endTimeStr, startDate, startTimeStr;
    if (!((moveDetails != null ? moveDetails.moved_to_event_start_at : void 0) && (moveDetails != null ? moveDetails.moved_to_event_end_at : void 0))) {
      return '';
    }
    startDate = new Date(moveDetails.moved_to_event_start_at);
    endDate = new Date(moveDetails.moved_to_event_end_at);
    dateStr = $filter('date')(startDate, 'EEE d MMM yyyy');
    startTimeStr = $filter('date')(startDate, 'h:mm a');
    endTimeStr = $filter('date')(endDate, 'h:mm a');
    return `${dateStr}, ${startTimeStr} - ${endTimeStr}`;
  };
}]);
